import React from 'react';
import PropTypes from 'prop-types';

import SeparatorLine from '@components/SeparatorLine';
import Button from '@components/RadioButton';
import SimpleButton from '@components/SimpleButton';

import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';
import Container from '../components/Container';
import Content from '../components/Content';
import TextContainer from '../components/TextContainer';
import Caption from '../components/Caption';
import Text from '../components/Text';
import Label from '../components/Label';
import SeparatorContainer from '../components/SeparatorContainer';
import ImageContainer from '../components/ImageContainer';
function RadioButton({
  label,
  text,
  caption,
  actionLabel,
  actionIcon,
  image,
  onSelect,
  selected,
  elementId,
  onClickButton,
}) {
  return (
    <div id={elementId}>
      <Container>
        <Content
          onClick={onSelect}
          tabIndex={0}
          onKeyUp={e => onKeyUpFunction(e, onSelect)}
          onKeyDown={e => onKeyDownFunction(e, onSelect)}
          aria-checked={selected}
          role="radio"
        >
          <Button selected={selected} />
          {image && <ImageContainer>{image}</ImageContainer>}
          <TextContainer onClick={onSelect}>
            <div>
              {label && <Label>{label}</Label>}
              <Text>{text}</Text>
            </div>
            <div>
              <Caption>{caption}</Caption>
            </div>
          </TextContainer>
        </Content>
        {actionIcon ||
          (actionLabel && (
            <SimpleButton
              label={actionLabel}
              size="small"
              onClickButton={onClickButton}
            />
          ))}
      </Container>

      <SeparatorContainer>
        <SeparatorLine />
      </SeparatorContainer>
    </div>
  );
}

RadioButton.propTypes = {
  text: PropTypes.string,
  label: PropTypes.string,
  caption: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  elementId: PropTypes.string,
  actionIcon: PropTypes.node,
  image: PropTypes.node,
  actionLabel: PropTypes.string,
  onClickButton: PropTypes.func,
};

export default RadioButton;
